export default "__VITE_PUBLIC_ASSET__c26cfe05__"